import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';

export default class EncounterChanges extends BackboneElement {
    static __className = 'EncounterChanges';

    __objectStructure = {
        field: String,
        fieldDisplay: String,
        oldValue: String,
        newValue: String,
    };

    constructor(constructJson, className = 'EncounterChanges') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
